import { EnvType } from '@metadata';
import Axios, { AxiosResponse } from 'axios';
import env from '../config/env';

const ENV = env();

const API_URL = `${ENV.BACKEND_API}`;
const AUTH_URL = `${ENV.AUTH_PATH}`;

const svcApi = Axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json;charset=UTF-8',
    'Content-type': 'application/json;charset=UTF-8',
  },
});

const authApi = Axios.create({
  baseURL: AUTH_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json;charset=UTF-8',
    'Content-type': 'application/json;charset=UTF-8',
  },
});


svcApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      alert("서버에 연결할 수 없습니다.");
      return Promise.reject(error);
    }

    const status = error.response.status;

    switch (status) {
      case 401:
        alert("로그인이 필요합니다.");
        window.location.href = "/main";
        break;

      case 403:
        alert("권한이 없습니다.");
        break;

      case 500:
        alert("서버 오류가 발생했습니다.");
        break;

      default:
        alert(error.response.data.message || "에러가 발생했습니다.");
    }

    return Promise.reject(error);
  }
);

export { svcApi, authApi };
